import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const DialogueModal = ({ isOpen, toggle, npc, onComplete }) => {
  const handleComplete = () => {
    if (onComplete && typeof onComplete === 'function') {
      onComplete(npc);
    }
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="dialogue-modal">
      <ModalHeader toggle={toggle}>
        {npc?.name || 'NPC'}
      </ModalHeader>
      <ModalBody>
        <div className="dialogue-content">
          {npc?.dialogue || 'Hello there!'}
        </div>
        {npc?.image && (
          <div className="npc-image-container text-center mt-3">
            <img 
              src={npc.image} 
              alt={npc.name || 'NPC'} 
              style={{ 
                maxWidth: '100px', 
                maxHeight: '100px',
                imageRendering: 'pixelated'
              }} 
            />
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleComplete}>
          {npc?.buttonText || 'Close'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DialogueModal;
